import { Flex, Grid, Text, Title } from '@mantine/core';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import RegimenFiscalEnum, { RegimenFiscalType } from '../../enum/RegimenFiscalEnum';

type Party = {
  name?: string;
  legal_name?: string;
  tax_id?: string;
  email?: string;
  tax_system?: string;
};

type SummaryItem = {
  label: string;
  value: ReactNode;
};

const renderTaxSystem = (taxSystem?: string) => {
  if (!taxSystem) return '-';
  return `${taxSystem} - ${RegimenFiscalEnum[taxSystem as RegimenFiscalType] || ''}`.trim();
};

export default function CFDIPreviewPartySummary({
  emisor,
  customer,
  summaryItems = [],
  hideCustomer = false
}: {
  emisor?: Party;
  customer?: Party;
  summaryItems?: SummaryItem[];
  hideCustomer?: boolean;
}) {
  const { t } = useTranslation(['CFDIPage', 'FieldName']);
  const columnSpan = summaryItems.length ? { xs: 12, md: 4 } : { xs: 12, md: 6 };

  return (
    <>
      <Grid.Col span={columnSpan}>
        <Flex direction="column">
          <Title order={4} ta="center" mt="md" mb={10}>
            {t('CFDIPage:preview.emisor')}
          </Title>
          <Text fw="bold">{t('FieldName:legal_name')}</Text>
          <Text>{emisor?.name || emisor?.legal_name || '-'}</Text>
          <Text fw="bold">{t('FieldName:tax_system')}</Text>
          <Text>{renderTaxSystem(emisor?.tax_system)}</Text>
        </Flex>
      </Grid.Col>
      {!hideCustomer && (
        <Grid.Col span={columnSpan}>
          <Flex direction="column">
            <Title order={4} ta="center" mt="md" mb={10}>
              {t('CFDIPage:preview.receptor')}
            </Title>
            <Text fw="bold">{t('FieldName:legal_name')}</Text>
            <Text>{customer?.legal_name || customer?.name || '-'}</Text>
            <Text fw="bold">{t('FieldName:rfc')}</Text>
            <Text>{customer?.tax_id || '-'}</Text>
            <Text fw="bold">{t('FieldName:email')}</Text>
            <Text>{customer?.email || '-'}</Text>
            <Text fw="bold">{t('FieldName:tax_system')}</Text>
            <Text>{renderTaxSystem(customer?.tax_system)}</Text>
          </Flex>
        </Grid.Col>
      )}
      {!!summaryItems.length && (
        <Grid.Col span={columnSpan}>
          <Flex direction="column">
            <Title order={4} ta="center" mt="md" mb={10}>
              {t('CFDIPage:preview.summary')}
            </Title>
            {summaryItems.map((item) => (
              <div key={item.label}>
                <Text fw="bold">{item.label}</Text>
                <Text>{item.value}</Text>
              </div>
            ))}
          </Flex>
        </Grid.Col>
      )}
    </>
  );
}
